import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TswpCoreMasterdataModule } from '@trustedshops/tswp-core-masterdata-implementation';
import { TswpCoreUiSharedModule } from '../../common/tswp-core-ui-shared.module';
import { ProductFeatureUpgradePageComponent } from './product-feature-upgrade-page.component';
import { ProductFeatureUpgradePageInitializer } from './product-feature-upgrade-page.bootstrapper';
import { ProductFeatureUpgradeTranslationService } from '../../services/product-feature-upgrade-translation.service';

@NgModule({
  imports: [CommonModule, TswpCoreMasterdataModule, TswpCoreUiSharedModule],
  declarations: [ProductFeatureUpgradePageComponent],
  providers: [
    ProductFeatureUpgradePageInitializer,
    ProductFeatureUpgradeTranslationService,
  ],
  exports: [ProductFeatureUpgradePageComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductFeatureUpgradePageModule {}
